module.exports = __webpack_public_path__ + "static/media/twitter.f9a8aedc.svg";